// extracted by mini-css-extract-plugin
export default {"baseFlex":"BasicInfoForm_baseFlex__bCLTv"};